module.exports = "/_next/static/images/btn_google_signin_dark_pressed_web@2x-422875cb120f11c2911a87bf1bbb4160.png";